import React from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const WaiterKitchenFilled = (props: IconProps) => {
    const { color = "#0E0E0E", ...rest } = props
    return (
        <svg width="24" height="21" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <g clipPath="url(#clip0_1441_27103)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.16406 17.5498L7.96819 13.2344L10.1864 13.1567C11.1339 13.271 12.0932 13.6855 13.0575 14.1704L14.7801 14.1104C15.5619 14.125 16.0022 14.8018 15.264 15.2822C14.678 15.6909 13.8795 15.6968 13.0592 15.6602C12.495 15.6558 12.5 16.3193 13.0876 16.3003C13.2919 16.3076 13.5128 16.2578 13.7054 16.2505C14.7249 16.2139 15.5569 16.0146 16.0391 15.291L16.2734 14.7549L18.7863 13.5537C20.0519 13.1392 20.904 14.1836 19.9967 15.0332C18.1936 16.2798 16.4475 17.4165 14.5357 18.269C13.1562 19.0703 11.74 19.0952 10.2935 18.417L8.16406 17.5498ZM6.97879 10.9741H22.3638C22.4777 10.9741 22.5714 11.0576 22.5714 11.1558V11.9482C22.5714 12.0464 22.4777 12.1299 22.3638 12.1299H6.97879C6.86496 12.1299 6.77121 12.0479 6.77121 11.9482V11.1558C6.77121 11.0562 6.86496 10.9741 6.97879 10.9741ZM15.269 3.39502C19.481 3.68945 23.0285 6.7876 22.5045 10.4351H6.83984C6.32254 6.76416 9.88337 3.66162 14.1256 3.39062V2.7959H13.4559C13.3387 2.7959 13.2416 2.71094 13.2416 2.6084V1.9375C13.2416 1.83496 13.3371 1.75 13.4559 1.75H15.9202C16.0374 1.75 16.1345 1.83496 16.1345 1.9375V2.6084C16.1345 2.71094 16.0374 2.7959 15.9202 2.7959H15.269V3.39502ZM2 13.0864L7.28181 12.8433L7.51618 18.0068L2.23438 18.2485L2 13.0864Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_1441_27103">
                    <rect width="20.5714" height="17.1519" fill="white" transform="translate(2 1.75)" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default WaiterKitchenFilled
